module.exports = __webpack_public_path__ + "static/innovare-logo-448497494b97b7fa9802fe0f72f9a6ba.png";